export enum EButtonColor {
  WHITE = 'white',
  BLACK = 'black',
  PINK = 'pink',
  EMPTY = 'empty',
}

export enum EButtonSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}

export type TIconPropType = {
  className?: string;
};
